import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Theme Color Meta Tag"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "theme-color-meta-tag"
    }}>{`Theme Color Meta Tag`}</h1>
    <p><em parentName="p">{`Learn more about `}<inlineCode parentName="em">{`<meta />`}</inlineCode>{` theme color on
`}<a parentName="em" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta/name/theme-color"
        }}>{`MDN`}</a>{`
and `}<a parentName="em" {...{
          "href": "https://css-tricks.com/meta-theme-color-and-trickery/"
        }}>{`CSS Tricks`}</a>{`.`}</em></p>
    <h3 {...{
      "id": "with-usethemeui"
    }}>{`with `}<inlineCode parentName="h3">{`useThemeUI`}</inlineCode></h3>
    <p>{`Grab your theme from the context with `}<inlineCode parentName="p">{`useThemeUI`}</inlineCode>{`, pick either a background
or accent color from the palette, then use your framework’s method of adding
a meta tag to add to `}<inlineCode parentName="p">{`<head />`}</inlineCode>{`.`}</p>
    <h4 {...{
      "id": "react-helmet-in-gatsby"
    }}><strong parentName="h4"><a parentName="strong" {...{
          "href": "https://github.com/nfl/react-helmet"
        }}><inlineCode parentName="a">{`react-helmet`}</inlineCode></a>{` in Gatsby`}</strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Helmet } from 'react-helmet'
import { useThemeUI } from 'theme-ui'

function Example() {
  const { theme } = useThemeUI()

  return (
    <Helmet>
      <meta name="theme-color" content={theme.colors.primary} />
    </Helmet>
  )
}
`}</code></pre>
    <h4 {...{
      "id": "nexthead-in-nextjs"
    }}><strong parentName="h4"><a parentName="strong" {...{
          "href": "https://nextjs.org/docs/api-reference/next/head"
        }}><inlineCode parentName="a">{`next/head`}</inlineCode></a>{` in Next.js`}</strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import Head from 'next/head'

function Example() {
  const { theme } = useThemeUI()

  return (
    <div>
      <Head>
        <title>My page title</title>
        <meta name="theme-color" content={theme.colors.background} />
      </Head>
      <p>Hello world!</p>
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "using-css-custom-properties"
    }}>{`using CSS Custom Properties`}</h3>
    <p>{`You can use custom CSS Properties added by `}<inlineCode parentName="p">{`theme-ui`}</inlineCode>{` to access the colors from
a static HTML file.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<meta
  name="theme-color"
  content="var(--theme-ui-colors-primary)"
  media="(prefers-color-scheme: light)"
/>
<meta
  name="theme-color"
  content="var(--theme-ui-colors-background)"
  media="(prefers-color-scheme: dark)"
/>
`}</code></pre>
    <hr></hr>
    <p><em parentName="p">{`Take note that `}<inlineCode parentName="em">{`@theme-ui/core`}</inlineCode>{` does not create CSS custom properties. This
recipe works only with the `}<inlineCode parentName="em">{`theme-ui`}</inlineCode>{` umbrella package.`}</em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      